import React, { useEffect, useState } from 'react';
import { TextField, Dropdown, Label, DatePicker } from 'office-ui-fabric-react';
import {
	onInputCellChange,
	moveToCellSheet,
	spiltTopRowCellValue,
} from 'utils/excelUtils/ExcelDataPopulate';
import ExcelCommonTexts from 'components/common/excel/ExcelCellText';

export const CellIdSheetName = ({
	cellNumber,
	sheetName,
	onRenderLabel,
	onChangeDispatch,
}) => {
	const [cellSheetValidErrMsg, setCellSheetValidErrMsg] = useState({
		invalidCellErrorMsg: '',
		invalidSeetErrorMsg: '',
	});

	const getSelectedCell = async () => {
		await Excel.run(async context => {
			const range = context.workbook.getSelectedRange();
			range.load(['address', 'worksheet']);
			await context.sync();
			const cellId = range.address.split('!')[1];
			const isFirstRowSelected = spiltTopRowCellValue(cellId);
			if (isFirstRowSelected) {
				setCellSheetValidErrMsg({
					invalidCellErrorMsg: ExcelCommonTexts.firstRowReserveMsg,
					invalidSeetErrorMsg: '',
				});
			} else {
				setCellSheetValidErrMsg({
					invalidCellErrorMsg: '',
					invalidSeetErrorMsg: '',
				});
			}
			onChangeDispatch(cellId, range.worksheet.name);
		});
	};

	useEffect(() => {
		let eventResult;
		if (!cellNumber || !sheetName) {
			setCellSheetValidErrMsg({
				invalidCellErrorMsg: !cellNumber
					? 'Please select cell number'
					: '',
				invalidSeetErrorMsg: !sheetName
					? 'Please select sheet name'
					: '',
			});
		}
		Office.onReady(() => {
			Excel.run(async context => {
				eventResult = context.workbook.onSelectionChanged.add(
					getSelectedCell,
				);
				await context.sync();
			});
		});
		return () => {
			Office.onReady(() => {
				Excel.run(eventResult.context, async context => {
					eventResult.remove();
					await context.sync();
					eventResult = null;
				});
			});
		};
	}, []);

	const onChangeCellSheetField = e => {
		const {
			cellValue,
			sheetName,
			isValidSheetName,
			isInputCellValid,
			isValidCellId,
			isFirstRowSelected,
		} = onInputCellChange(e);
		const errMsg = { invalidSeetErrorMsg: '', invalidCellErrorMsg: '' };
		if (!isValidSheetName) {
			errMsg.invalidSeetErrorMsg =
				ExcelCommonTexts.emptySheetNameErrorMsg;
		}
		if (!isValidCellId) {
			errMsg.invalidCellErrorMsg = ExcelCommonTexts.emptyCellIdErrorMsg;
		}
		if (isFirstRowSelected) {
			errMsg.invalidCellErrorMsg = ExcelCommonTexts.firstRowReserveMsg;
		}
		setCellSheetValidErrMsg(errMsg);
		onChangeDispatch(cellValue, sheetName);
	};

	return (
		<>
			<div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
				<TextField
					label={ExcelCommonTexts.createCellLabel}
					id="cellNumber"
					name="cellNumber"
					readOnly=""
					placeholder={ExcelCommonTexts.createCellLabel}
					value={cellNumber}
					onChange={e => onChangeCellSheetField(e)}
					required
					errorMessage={cellSheetValidErrMsg.invalidCellErrorMsg}
					tooltipMessage={ExcelCommonTexts.cellIdToolTipMsg}
					onRenderLabel={onRenderLabel}
				/>
			</div>
			<div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
				<TextField
					label={ExcelCommonTexts.createSheetLabel}
					id="sheetName"
					name="sheetName"
					readOnly=""
					placeholder={ExcelCommonTexts.createSheetLabel}
					value={sheetName}
					onChange={e => onChangeCellSheetField(e)}
					required
					errorMessage={cellSheetValidErrMsg.invalidSeetErrorMsg}
					tooltipMessage={ExcelCommonTexts.sheetNameToolTipMsg}
					onRenderLabel={onRenderLabel}
				/>
			</div>
		</>
	);
};
